"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Abillity_Mirror_OnAbilityUsedEventHandlerScript = void 0;
const __1 = require("../..");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Abillity_Mirror_OnAbilityUsedEventHandlerScript = class Abillity_Mirror_OnAbilityUsedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.AbilityUsed) {
            return;
        }
        const { target } = event.args.args;
        const targetIds = container.selectLivingTargets(handler.args.scriptArgs.cloneId, target)
            .filter(targetId => container.getFaction(targetId) !== container.getFaction(handler.args.scriptArgs.cloneId));
        if (targetIds.length === 0) {
            return;
        }
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: "FrostAndFireBolt",
            attackerId: handler.args.scriptArgs.cloneId,
            attackType: "magic",
            projectiles: targetIds.map(targetId => ({
                targetId,
                path: "line",
                type: "FrostFireBolt",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Frost", 25),
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 25),
                ],
                jitter: (0, __1.random)(25, 75)
            }))
        });
    }
};
Abillity_Mirror_OnAbilityUsedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Abillity_Mirror_OnAbilityUsed")
], Abillity_Mirror_OnAbilityUsedEventHandlerScript);
exports.Abillity_Mirror_OnAbilityUsedEventHandlerScript = Abillity_Mirror_OnAbilityUsedEventHandlerScript;
